<template>
  <section class="home">
    <v-sheet class="clipDetail-clip_video home_video">
      <ClipVideo v-if="showPlayback && !clipListLoading" />
      <clip-video-skeleton v-else />
    </v-sheet>
    <ClipList class="home_events" />
  </section>
</template>

<script>
import ClipList from '@/components/clips/ClipList.vue';
import ClipVideo from '@/components/clips/ClipVideo.vue';
import { mapActions, mapState } from 'vuex';
import ClipVideoSkeleton from '@/components/skeletons/ClipVideoSkeleton.vue';
import EventBus from '@/utils/eventBus';
import { EventBusEvents } from '@/globals/enums';

export default {
  name: 'ClipDetail',
  components: {
    ClipList,
    ClipVideo,
    ClipVideoSkeleton,
  },
  data() {
    return {
      showPlayback: false,
    };
  },
  computed: {
    ...mapState({
      videoClips: (state) =>
        state.video.videoClips.map((item, index) => ({ ...item, index })),
      clipListLoading: (state) => state.video.clipListLoading,
      currentCameraPolicy: (state) => state.common.currentCameraPolicy,
      isCurrentAvatarOwner: (state) => state.settings.isCurrentAvatarOwner,
    }),
    canUserAccess() {
      return this.isCurrentAvatarOwner || !this.currentCameraPolicy.liveOnly;
    },
    clipId() {
      return Number(this.$route.params.id);
    },
  },
  watch: {
    canUserAccess(val) {
      if (!val) {
        this.routerPush({ name: 'home' });
      }
    },
    clipListLoading: {
      handler: function (val) {
        if (!val) {
          this.setVideoClip();
        }
      },
    },
    clipId: {
      handler: function (val) {
        if (val) {
          this.showPlayback = false;
          this.changeVideoClip(this.videoClips.find((item) => item.id === val));
          setTimeout(() => {
            this.showPlayback = true;
          }, 5);
        }
      },
    },
  },
  mounted() {
    EventBus.on(EventBusEvents.CamGroupChanged, this.handleCamGroupChanged);
  },
  beforeDestroy() {
    EventBus.off(EventBusEvents.CamGroupChanged, this.handleCamGroupChanged);
  },
  methods: {
    ...mapActions('video', ['changeVideoClip']),
    async setVideoClip() {
      this.showPlayback = false;
      const targetClip = this.videoClips.find(
        (item) => item.id === this.clipId
      );
      this.changeVideoClip(targetClip);
      setTimeout(() => {
        this.showPlayback = true;
      }, 5);
    },
    handleCamGroupChanged() {
      // navigate to home if user only has live permission, otherwise go to clip list
      if (!this.canUserAccess) {
        this.routerPush({ name: 'home' });
      } else {
        this.routerPush({ name: 'clip' });
      }
    },
  },
};
</script>

<style lang="scss">
.clipDetail {
  &-clip_video {
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    &.v-sheet {
      padding: 0;
    }
  }
}
</style>
